import styled from 'styled-components';

export const Text = styled.span`
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0;
  display: inline-flex;
  align-items: center;

  > img {
    margin-right: 8px;
  }

  .tooltip {
    cursor: pointer;
    display: flex;
    align-items: center;
    margin-left: 8px;
  }
`;
